import React, { useState } from "react";
import Box from "@mui/material/Box";
import AppTabs from "../Common/Tabs/AppTabs";
import UploadCDForm from "./UploadCDForm";
import GetCDForm from "./GetCDForm";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";

const MATTER_CD_TABS = [
  { label: "Upload CD" },
  { label: "Get CD" },
];

const MatterCD = () => {
  const [activeTab, setActiveTab] = useState(0);

  React.useEffect(() => {
    const switchToUploadTabHandler = () => setActiveTab(0);
    window.addEventListener("switchToUploadTab", switchToUploadTabHandler);
    return () => {
      window.removeEventListener("switchToUploadTab", switchToUploadTabHandler);
    };
  }, []);

  return (
    <ResponsiveContentWrapper>
      <Box sx={{ width: "100%", minWidth: 0 }}>
        <AppTabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          tabs={MATTER_CD_TABS}
          variant="scrollable"
          scrollButtons="auto"
          tabMinWidth="auto"
          appearance="neutral"
        />
        <Box sx={{ mt: 2 }}>
          {activeTab === 0 && <UploadCDForm activeTab={activeTab} />}
          {activeTab === 1 && <GetCDForm />}
        </Box>
      </Box>
    </ResponsiveContentWrapper>
  );
};

export default MatterCD;
